import { Badge } from "@xola/ui-kit";
import React from "react";

type BadgeSize = "small" | "medium" | "large";

interface ProductBadgeProps {
    color?: string;
    text: string | React.ReactElement;
    icon: React.ReactElement;
    size: BadgeSize;
}

export const ProductBadge = ({ color = "secondary", text, icon, size }: ProductBadgeProps) => {
    return (
        <Badge color={color} size={size} icon={icon}>
            {text}
        </Badge>
    );
};
